<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>people</md-icon>
          </div>
          <h4 class="title">Drones List</h4>
        </md-card-header>
        <md-card-content>
          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">Per page</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                    v-for="(item, position) in pagination.perPageOptions"
                    :key="position"
                    :label="item"
                    :value="item"
                    >{{ item }}</md-option
                  >
                </md-select>
              </md-field>

              <md-field>
                <md-input
                  type="search"
                  class="mb-3"
                  clearable
                  style="width: 200px"
                  placeholder="Search records"
                  v-model="searchQuery"
                ></md-input>
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Brand">{{
                item["Brand"]
              }}</md-table-cell>
              <md-table-cell md-label="Model">{{
                item["DroneName"]
              }}</md-table-cell>
              <md-table-cell md-label="TC Credit">{{
                item["TCCredit"]
              }}</md-table-cell>
              <md-table-cell md-label="Controlled Airspace">{{
                item["Controlledairspace"]
              }}</md-table-cell>
              <md-table-cell md-label="Near People">{{
                item["Nearpeople"]
              }}</md-table-cell>
              <md-table-cell md-label="Over People">{{
                item["Overpeople"]
              }}</md-table-cell>
              <md-table-cell>
                <md-button
                  class="md-just-icon md-simple"
                  @click="showEditor(item)"
                >
                  <md-icon>create</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>

        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></pagination>
        </md-card-actions>
      </md-card>

      <modal v-if="editing">
        <template slot="header">
          <md-button
            class="md-simple md-just-icon md-round modal-default-button"
            @click="closeEditor"
          >
            <md-icon>clear</md-icon>
          </md-button>
        </template>
        <template slot="body">
          <md-card>
            <md-card-header class="md-card-header-icon md-card-header-warning">
              <div class="card-icon">
                <md-icon>people</md-icon>
              </div>
              <h4 class="title" style="text-align:left">RPAS Details</h4>
            </md-card-header>
            <md-content-card style="height: 400px; overflow-y: auto">
              <md-field
                :class="[
                  { 'md-valid': !errors.has('Brand') && touched.Brand },
                  { 'md-error': errors.has('Brand') }
                ]"
              >
                <label>Brand</label>
                <md-input
                  name="Brand"
                  data-vv-name="Brand"
                  v-model="drone.Brand"
                  required
                  v-validate="'required|min:3'"
                  type="text"
                ></md-input>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('Brand')"
                    >close</md-icon
                  >
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="!errors.has('Brand')"
                    >done</md-icon
                  >
                </slide-y-down-transition>
              </md-field>

              <md-field
                :class="[
                  { 'md-valid': !errors.has('DroneName') && touched.DroneName },
                  { 'md-error': errors.has('DroneName') }
                ]"
              >
                <label>Model Name</label>
                <md-input
                  name="DroneName"
                  data-vv-name="DroneName"
                  v-model="drone.DroneName"
                  required
                  v-validate="'required|min:2'"
                  type="text"
                ></md-input>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('DroneName')"
                    >close</md-icon
                  >
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="!errors.has('DroneName')"
                    >done</md-icon
                  >
                </slide-y-down-transition>
              </md-field>

              <md-field
                :class="[
                  { 'md-valid': !errors.has('TCCredit') && touched.TCCredit },
                  { 'md-error': errors.has('TCCredit') }
                ]"
              >
                <label>TC Credit (Yes / No)</label>
                <md-input
                  name="TCCredit"
                  data-vv-name="TCCredit"
                  v-model="drone.TCCredit"
                  required
                  v-validate="'required|min:2'"
                  type="text"
                ></md-input>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('TCCredit')"
                    >close</md-icon
                  >
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="!errors.has('TCCredit')"
                    >done</md-icon
                  >
                </slide-y-down-transition>
              </md-field>

              <md-field
                :class="[
                  {
                    'md-valid':
                      !errors.has('TakeoffWeight') && touched.TakeoffWeight
                  },
                  { 'md-error': errors.has('TakeoffWeight') }
                ]"
              >
                <label>Takeoff Weight</label>
                <md-input
                  name="TakeoffWeight"
                  data-vv-name="TakeoffWeight"
                  v-model="drone.TakeoffWeight"
                  v-validate="'min:2'"
                  type="text"
                ></md-input>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('TakeoffWeight')"
                    >close</md-icon
                  >
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="!errors.has('TakeoffWeight')"
                    >done</md-icon
                  >
                </slide-y-down-transition>
              </md-field>

              <md-field
                :class="[
                  {
                    'md-valid':
                      !errors.has('MaxServiceCeilingAboveSeaLevel') &&
                      touched.MaxServiceCeilingAboveSeaLevel
                  },
                  { 'md-error': errors.has('MaxServiceCeilingAboveSeaLevel') }
                ]"
              >
                <label>MaxService Ceiling Above Sea Level</label>
                <md-input
                  name="MaxServiceCeilingAboveSeaLevel"
                  data-vv-name="MaxServiceCeilingAboveSeaLevel"
                  v-model="drone.MaxServiceCeilingAboveSeaLevel"
                  v-validate="'min:2'"
                  type="text"
                ></md-input>
                <slide-y-down-transition>
                  <md-icon
                    class="error"
                    v-show="errors.has('MaxServiceCeilingAboveSeaLevel')"
                    >close</md-icon
                  >
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon
                    class="success"
                    v-show="!errors.has('MaxServiceCeilingAboveSeaLevel')"
                    >done</md-icon
                  >
                </slide-y-down-transition>
              </md-field>

              <md-field
                :class="[
                  {
                    'md-valid':
                      !errors.has('OperatingTemperatureRangeLow') &&
                      touched.OperatingTemperatureRangeLow
                  },
                  { 'md-error': errors.has('OperatingTemperatureRangeLow') }
                ]"
              >
                <label>Operating Temperature Range Low</label>
                <md-input
                  name="OperatingTemperatureRangeLow"
                  data-vv-name="OperatingTemperatureRangeLow"
                  v-model="drone.OperatingTemperatureRangeLow"
                  v-validate="'min:2'"
                  type="text"
                ></md-input>
                <slide-y-down-transition>
                  <md-icon
                    class="error"
                    v-show="errors.has('OperatingTemperatureRangeLow')"
                    >close</md-icon
                  >
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon
                    class="success"
                    v-show="!errors.has('OperatingTemperatureRangeLow')"
                    >done</md-icon
                  >
                </slide-y-down-transition>
              </md-field>

              <md-field
                :class="[
                  {
                    'md-valid':
                      !errors.has('OperatingTemperatureRangeHigh') &&
                      touched.OperatingTemperatureRangeHigh
                  },
                  { 'md-error': errors.has('OperatingTemperatureRangeHigh') }
                ]"
              >
                <label>Operating Temperature Range High</label>
                <md-input
                  name="OperatingTemperatureRangeHigh"
                  data-vv-name="OperatingTemperatureRangeHigh"
                  v-model="drone.OperatingTemperatureRangeHigh"
                  v-validate="'min:2'"
                  type="text"
                ></md-input>
                <slide-y-down-transition>
                  <md-icon
                    class="error"
                    v-show="errors.has('OperatingTemperatureRangeHigh')"
                    >close</md-icon
                  >
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon
                    class="success"
                    v-show="!errors.has('OperatingTemperatureRangeHigh')"
                    >done</md-icon
                  >
                </slide-y-down-transition>
              </md-field>

              <md-field
                :class="[
                  {
                    'md-valid':
                      !errors.has('Controlledairspace') &&
                      touched.Controlledairspace
                  },
                  { 'md-error': errors.has('Controlledairspace') }
                ]"
              >
                <label>Controlled Airspace (Yes / No)</label>
                <md-input
                  name="Controlledairspace"
                  data-vv-name="Controlledairspace"
                  v-model="drone.Controlledairspace"
                  v-validate="'required|min:2'"
                  type="text"
                ></md-input>
                <slide-y-down-transition>
                  <md-icon
                    class="error"
                    v-show="errors.has('Controlledairspace')"
                    >close</md-icon
                  >
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon
                    class="success"
                    v-show="!errors.has('Controlledairspace')"
                    >done</md-icon
                  >
                </slide-y-down-transition>
              </md-field>

              <md-field
                :class="[
                  {
                    'md-valid': !errors.has('Nearpeople') && touched.Nearpeople
                  },
                  { 'md-error': errors.has('Nearpeople') }
                ]"
              >
                <label>Near People (Yes / No)</label>
                <md-input
                  name="Nearpeople"
                  data-vv-name="Nearpeople"
                  v-model="drone.Nearpeople"
                  v-validate="'required|min:2'"
                  type="text"
                ></md-input>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('Nearpeople')"
                    >close</md-icon
                  >
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="!errors.has('Nearpeople')"
                    >done</md-icon
                  >
                </slide-y-down-transition>
              </md-field>

              <md-field
                :class="[
                  {
                    'md-valid': !errors.has('Overpeople') && touched.Overpeople
                  },
                  { 'md-error': errors.has('Overpeople') }
                ]"
              >
                <label>Over People (Yes / No)</label>
                <md-input
                  name="Overpeople"
                  data-vv-name="Overpeople"
                  v-model="drone.Overpeople"
                  v-validate="'required|min:2'"
                  type="text"
                ></md-input>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('Overpeople')"
                    >close</md-icon
                  >
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="!errors.has('Overpeople')"
                    >done</md-icon
                  >
                </slide-y-down-transition>
              </md-field>

              <md-field
                :class="[
                  {
                    'md-valid':
                      !errors.has('TakeoffWeighting') &&
                      touched.TakeoffWeighting
                  },
                  { 'md-error': errors.has('TakeoffWeighting') }
                ]"
              >
                <label>Takeoff Weight (g)</label>
                <md-input
                  name="TakeoffWeighting"
                  data-vv-name="TakeoffWeighting"
                  v-model="drone.TakeoffWeighting"
                  v-validate="'min:2'"
                  type="text"
                ></md-input>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('TakeoffWeighting')"
                    >close</md-icon
                  >
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon
                    class="success"
                    v-show="!errors.has('TakeoffWeighting')"
                    >done</md-icon
                  >
                </slide-y-down-transition>
              </md-field>

              <md-field
                :class="[
                  {
                    'md-valid':
                      !errors.has('MaxDistance') && touched.MaxDistance
                  },
                  { 'md-error': errors.has('MaxDistance') }
                ]"
              >
                <label>MaxDistance</label>
                <md-input
                  name="MaxDistance"
                  data-vv-name="MaxDistance"
                  v-model="drone.MaxDistance"
                  v-validate="'min:2'"
                  type="text"
                ></md-input>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('MaxDistance')"
                    >close</md-icon
                  >
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="!errors.has('MaxDistance')"
                    >done</md-icon
                  >
                </slide-y-down-transition>
              </md-field>

              <md-field
                :class="[
                  {
                    'md-valid':
                      !errors.has('MaxAscentSpeed') && touched.MaxAscentSpeed
                  },
                  { 'md-error': errors.has('MaxAscentSpeed') }
                ]"
              >
                <label>MaxAscentSpeed</label>
                <md-input
                  name="MaxAscentSpeed"
                  data-vv-name="MaxAscentSpeed"
                  v-model="drone.MaxAscentSpeed"
                  v-validate="'min:2'"
                  type="text"
                ></md-input>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('MaxAscentSpeed')"
                    >close</md-icon
                  >
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon
                    class="success"
                    v-show="!errors.has('MaxAscentSpeed')"
                    >done</md-icon
                  >
                </slide-y-down-transition>
              </md-field>

              <md-field
                :class="[
                  {
                    'md-valid':
                      !errors.has('MaxDescentSpeed') && touched.MaxDescentSpeed
                  },
                  { 'md-error': errors.has('MaxDescentSpeed') }
                ]"
              >
                <label>MaxDescentSpeed</label>
                <md-input
                  name="MaxDescentSpeed"
                  data-vv-name="MaxDescentSpeed"
                  v-model="drone.MaxDescentSpeed"
                  v-validate="'min:2'"
                  type="text"
                ></md-input>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('MaxDescentSpeed')"
                    >close</md-icon
                  >
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon
                    class="success"
                    v-show="!errors.has('MaxDescentSpeed')"
                    >done</md-icon
                  >
                </slide-y-down-transition>
              </md-field>

              <md-field
                :class="[
                  { 'md-valid': !errors.has('MaxSpeed') && touched.MaxSpeed },
                  { 'md-error': errors.has('MaxSpeed') }
                ]"
              >
                <label>MaxSpeed</label>
                <md-input
                  name="MaxSpeed"
                  data-vv-name="MaxSpeed"
                  v-model="drone.MaxSpeed"
                  v-validate="'min:2'"
                  type="text"
                ></md-input>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('MaxSpeed')"
                    >close</md-icon
                  >
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="!errors.has('MaxSpeed')"
                    >done</md-icon
                  >
                </slide-y-down-transition>
              </md-field>

              <md-field
                :class="[
                  {
                    'md-valid':
                      !errors.has('MaxWindResistance') &&
                      touched.MaxWindResistance
                  },
                  { 'md-error': errors.has('MaxWindResistance') }
                ]"
              >
                <label>MaxWindResistance</label>
                <md-input
                  name="MaxWindResistance"
                  data-vv-name="MaxWindResistance"
                  v-model="drone.MaxWindResistance"
                  v-validate="'min:2'"
                  type="text"
                ></md-input>
                <slide-y-down-transition>
                  <md-icon
                    class="error"
                    v-show="errors.has('MaxWindResistance')"
                    >close</md-icon
                  >
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon
                    class="success"
                    v-show="!errors.has('MaxWindResistance')"
                    >done</md-icon
                  >
                </slide-y-down-transition>
              </md-field>

              <md-field
                :class="[
                  { 'md-valid': !errors.has('Battery') && touched.Battery },
                  { 'md-error': errors.has('Battery') }
                ]"
              >
                <label>Battery</label>
                <md-input
                  name="Battery"
                  data-vv-name="Battery"
                  v-model="drone.Battery"
                  v-validate="'min:2'"
                  type="text"
                ></md-input>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('Battery')"
                    >close</md-icon
                  >
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="!errors.has('Battery')"
                    >done</md-icon
                  >
                </slide-y-down-transition>
              </md-field>

              <md-field
                :class="[
                  {
                    'md-valid':
                      !errors.has('MaxFlightTime') && touched.MaxFlightTime
                  },
                  { 'md-error': errors.has('MaxFlightTime') }
                ]"
              >
                <label>MaxFlightTime</label>
                <md-input
                  name="MaxFlightTime"
                  data-vv-name="MaxFlightTime"
                  v-model="drone.MaxFlightTime"
                  v-validate="'min:2'"
                  type="text"
                ></md-input>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('MaxFlightTime')"
                    >close</md-icon
                  >
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="!errors.has('MaxFlightTime')"
                    >done</md-icon
                  >
                </slide-y-down-transition>
              </md-field>

              <md-field
                :class="[
                  {
                    'md-valid':
                      !errors.has('RemoteBattery') && touched.RemoteBattery
                  },
                  { 'md-error': errors.has('RemoteBattery') }
                ]"
              >
                <label>RemoteBattery</label>
                <md-input
                  name="RemoteBattery"
                  data-vv-name="RemoteBattery"
                  v-model="drone.RemoteBattery"
                  v-validate="'min:2'"
                  type="text"
                ></md-input>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('RemoteBattery')"
                    >close</md-icon
                  >
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="!errors.has('RemoteBattery')"
                    >done</md-icon
                  >
                </slide-y-down-transition>
              </md-field>

              <md-field
                :class="[
                  {
                    'md-valid':
                      !errors.has('MaxTransmissionDistance') &&
                      touched.MaxTransmissionDistance
                  },
                  { 'md-error': errors.has('MaxTransmissionDistance') }
                ]"
              >
                <label>MaxTransmissionDistance</label>
                <md-input
                  name="MaxTransmissionDistance"
                  data-vv-name="MaxTransmissionDistance"
                  v-model="drone.MaxTransmissionDistance"
                  v-validate="'min:2'"
                  type="text"
                ></md-input>
                <slide-y-down-transition>
                  <md-icon
                    class="error"
                    v-show="errors.has('MaxTransmissionDistance')"
                    >close</md-icon
                  >
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon
                    class="success"
                    v-show="!errors.has('MaxTransmissionDistance')"
                    >done</md-icon
                  >
                </slide-y-down-transition>
              </md-field>
            </md-content-card>
          </md-card>
        </template>
        <template slot="footer">
          <md-button class="md-success md-simple" @click="validate"
            >Save</md-button
          >
          <md-button
            class="md-danger md-simple"
            @click="deleteDrone"
            :disabled="isNew"
            >Delete</md-button
          >
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import swal from "sweetalert2";
import { mapMultiRowFields } from "vuex-map-fields";
import { router } from "../../../main";
import { Modal } from "@/components";
import { SlideYDownTransition } from "vue2-transitions";

export default {
  $_veeValidate: {
    validator: "new"
  },
  components: {
    Pagination,
    Modal,
    SlideYDownTransition
  },
  data() {
    return {
      currentSort: "Brand, ModelName",
      currentSortOrder: "asc",
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [10, 25, 50, 100],
        total: 0
      },
      searchQuery: "",
      searchedData: [],
      fuseSearch: null,
      drone: {
        ID: "",
        Brand: "",
        BrandShort: "",
        DroneName: "",
        TCCredit: "",
        TakeoffWeight: "",
        MaxServiceCeilingAboveSeaLevel: "",
        OperatingTemperatureRangeLow: "",
        OperatingTemperatureRangeHigh: "",
        Controlledairspace: "",
        Nearpeople: "",
        Overpeople: "",
        TakeoffWeighting: "",
        MaxDistance: "",
        MaxAscentSpeed: "",
        MaxDescentSpeed: "",
        MaxSpeed: "",
        MaxWindResistance: "",
        Battery: "",
        MaxFlightTime: "",
        RemoteBattery: "",
        MaxTransmissionDistance: ""
      },
      editing: false,
      isNew: false,
      position: 0,
      start: "",
      end: "",
      errorMsg: "",
      touched: {
        ID: false,
        Brand: false,
        BrandShort: false,
        DroneName: false,
        TCCredit: false,
        TakeoffWeight: false,
        MaxServiceCeilingAboveSeaLevel: false,
        OperatingTemperatureRangeLow: false,
        OperatingTemperatureRangeHigh: false,
        Controlledairspace: false,
        Nearpeople: false,
        Overpeople: false,
        TakeoffWeighting: false,
        MaxDistance: false,
        MaxAscentSpeed: false,
        MaxDescentSpeed: false,
        MaxSpeed: false,
        MaxWindResistance: false,
        Battery: false,
        MaxFlightTime: false,
        RemoteBattery: false,
        MaxTransmissionDistance: false
      }
    };
  },
  watch: {
    ID() {
      this.touched.ID = true;
    },
    Brand() {
      this.touched.Brand = true;
    },
    BrandShort() {
      this.touched.BrandShort = true;
    },
    DroneName() {
      this.touched.DroneName = true;
    },
    TCCredit() {
      this.touched.TCCredit = true;
    },
    TakeoffWeight() {
      this.touched.TakeoffWeight = true;
    },
    MaxServiceCeilingAboveSeaLevel() {
      this.touched.MaxServiceCeilingAboveSeaLevel = true;
    },
    OperatingTemperatureRangeLow() {
      this.touched.OperatingTemperatureRangeLow = true;
    },
    OperatingTemperatureRangeHigh() {
      this.touched.OperatingTemperatureRangeHigh = true;
    },
    Controlledairspace() {
      this.touched.Controlledairspace = true;
    },
    Nearpeople() {
      this.touched.Nearpeople = true;
    },
    Overpeople() {
      this.touched.Overpeople = true;
    },
    TakeoffWeighting() {
      this.touched.TakeoffWeighting = true;
    },
    MaxDistance() {
      this.touched.MaxDistance = true;
    },
    MaxAscentSpeed() {
      this.touched.MaxAscentSpeed = true;
    },
    MaxDescentSpeed() {
      this.touched.MaxDescentSpeed = true;
    },
    MaxSpeed() {
      this.touched.MaxSpeed = true;
    },
    MaxWindResistance() {
      this.touched.MaxWindResistance = true;
    },
    Battery() {
      this.touched.Battery = true;
    },
    MaxFlightTime() {
      this.touched.MaxFlightTime = true;
    },
    RemoteBattery() {
      this.touched.RemoteBattery = true;
    },
    MaxTransmissionDistance() {
      this.touched.MaxTransmissionDistance = true;
    }
  },
  computed: {
    blur: function() {
      return this.editing;
    },
    ...mapMultiRowFields("drone", ["dronesList"]),
    queriedData() {
      let result = this.dronesList;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.dronesList.length;
    }
  },
  methods: {
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "asc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
    showEditor(item) {
      this.editing = true;

      this.drone.Brand = item["Brand"];
      this.drone.BrandShort = item["BrandShort"];
      this.drone.DroneName = item["DroneName"];
      this.drone.TCCredit = item["TCCredit"];
      this.drone.TakeoffWeight = item["TakeoffWeight"];
      this.drone.MaxServiceCeilingAboveSeaLevel =
        item["MaxServiceCeilingAboveSeaLevel"];
      this.drone.OperatingTemperatureRangeLow =
        item["OperatingTemperatureRangeLow"];
      this.drone.OperatingTemperatureRangeHigh =
        item["OperatingTemperatureRangeHigh"];
      this.drone.Controlledairspace = item["Controlledairspace"];
      this.drone.Nearpeople = item["Nearpeople"];
      this.drone.Overpeople = item["Overpeople"];
      this.drone.TakeoffWeighting = item["TakeoffWeighting"];
      this.drone.MaxDistance = item["MaxDistance"];
      this.drone.MaxAscentSpeed = item["MaxAscentSpeed"];
      this.drone.MaxDescentSpeed = item["MaxDescentSpeed"];
      this.drone.MaxSpeed = item["MaxSpeed"];
      this.drone.MaxWindResistance = item["MaxWindResistance"];
      this.drone.Battery = item["Battery"];
      this.drone.MaxFlightTime = item["MaxFlightTime"];
      this.drone.RemoteBattery = item["RemoteBattery"];
      this.drone.MaxTransmissionDistance = item["MaxTransmissionDistance"];

      this.isNew =
        !item["Brand"] &&
        !item["BrandShort"] &&
        !item["DroneName"] &&
        !item["TCCredit"] &&
        !item["TakeoffWeight"] &&
        !item["MaxServiceCeilingAboveSeaLevel"] &&
        !item["OperatingTemperatureRangeLow"] &&
        !item["OperatingTemperatureRangeHigh"] &&
        !item["Controlledairspace"] &&
        !item["Nearpeople"] &&
        !item["Overpeople"] &&
        !item["TakeoffWeighting"] &&
        !item["MaxDistance"] &&
        !item["MaxAscentSpeed"] &&
        !item["MaxDescentSpeed"] &&
        !item["MaxSpeed"] &&
        !item["MaxWindResistance"] &&
        !item["Battery"] &&
        !item["MaxFlightTime"] &&
        !item["RemoteBattery"] &&
        !item["MaxTransmissionDistance"];
    },
    closeEditor() {
      this.editing = false;
    },
    validate() {
      return this.$validator.validateAll().then(isValid => {
        if (!isValid) return;

        if (this.isNew) {
          this.addDrone();
        } else {
          this.updateDrone();
        }
      });
    },
    addDrone() {
      this.$store
        .dispatch("drone/addDrone", {
          Brand: this.drone.Brand,
          BrandShort: this.drone.BrandShort,
          DroneName: this.drone.DroneName,
          TCCredit: this.drone.TCCredit,
          TakeoffWeight: this.drone.TakeoffWeight,
          MaxServiceCeilingAboveSeaLevel: this.drone
            .MaxServiceCeilingAboveSeaLevel,
          OperatingTemperatureRangeLow: this.drone.OperatingTemperatureRangeLow,
          OperatingTemperatureRangeHigh: this.drone
            .OperatingTemperatureRangeHigh,
          Controlledairspace: this.drone.Controlledairspace,
          Nearpeople: this.drone.Nearpeople,
          Overpeople: this.drone.Overpeople,
          TakeoffWeighting: this.drone.TakeoffWeighting,
          MaxDistance: this.drone.MaxDistance,
          MaxAscentSpeed: this.drone.MaxAscentSpeed,
          MaxDescentSpeed: this.drone.MaxDescentSpeed,
          MaxSpeed: this.drone.MaxSpeed,
          MaxWindResistance: this.drone.MaxWindResistance,
          Battery: this.drone.Battery,
          MaxFlightTime: this.drone.MaxFlightTime,
          RemoteBattery: this.drone.RemoteBattery,
          MaxTransmissionDistance: this.drone.MaxTransmissionDistance
        })
        .then(() => {
          if (this.errorMsg != "") {
            swal
              .fire({
                title: "Cannot Add Drone",
                text: this.$t(this.errorMsg),
                type: "error",
                confirmButtonClass: "md-button md-error",
                buttonsStyling: false
              })
              .then(() => {
                this.errorMsg = "";
                this.editing = false;
              });
          } else {
            this.editing = false;
          }
        });
    },
    deleteDrone() {
      this.$store
        .dispatch("drone/deleteDrone", {
          Brand: this.drone.Brand,
          BrandShort: this.drone.BrandShort,
          DroneName: this.drone.DroneName,
          TCCredit: this.drone.TCCredit,
          TakeoffWeight: this.drone.TakeoffWeight,
          MaxServiceCeilingAboveSeaLevel: this.drone
            .MaxServiceCeilingAboveSeaLevel,
          OperatingTemperatureRangeLow: this.drone.OperatingTemperatureRangeLow,
          OperatingTemperatureRangeHigh: this.drone
            .OperatingTemperatureRangeHigh,
          Controlledairspace: this.drone.Controlledairspace,
          Nearpeople: this.drone.Nearpeople,
          Overpeople: this.drone.Overpeople,
          TakeoffWeighting: this.drone.TakeoffWeighting,
          MaxDistance: this.drone.MaxDistance,
          MaxAscentSpeed: this.drone.MaxAscentSpeed,
          MaxDescentSpeed: this.drone.MaxDescentSpeed,
          MaxSpeed: this.drone.MaxSpeed,
          MaxWindResistance: this.drone.MaxWindResistance,
          Battery: this.drone.Battery,
          MaxFlightTime: this.drone.MaxFlightTime,
          RemoteBattery: this.drone.RemoteBattery,
          MaxTransmissionDistance: this.drone.MaxTransmissionDistance
        })
        .then(() => {
          if (this.errorMsg != "") {
            swal
              .fire({
                title: "Cannot Delete Drone",
                text: this.$t(this.errorMsg),
                type: "error",
                confirmButtonClass: "md-button md-error",
                buttonsStyling: false
              })
              .then(() => {
                this.errorMsg = "";
                this.editing = false;
              });
          } else {
            this.editing = false;
          }
        });
    },
    updateDrone() {
      this.$store
        .dispatch("drone/updateDrone", {
          Brand: this.drone.Brand,
          BrandShort: this.drone.BrandShort,
          DroneName: this.drone.DroneName,
          TCCredit: this.drone.TCCredit,
          TakeoffWeight: this.drone.TakeoffWeight,
          MaxServiceCeilingAboveSeaLevel: this.drone
            .MaxServiceCeilingAboveSeaLevel,
          OperatingTemperatureRangeLow: this.drone.OperatingTemperatureRangeLow,
          OperatingTemperatureRangeHigh: this.drone
            .OperatingTemperatureRangeHigh,
          Controlledairspace: this.drone.Controlledairspace,
          Nearpeople: this.drone.Nearpeople,
          Overpeople: this.drone.Overpeople,
          TakeoffWeighting: this.drone.TakeoffWeighting,
          MaxDistance: this.drone.MaxDistance,
          MaxAscentSpeed: this.drone.MaxAscentSpeed,
          MaxDescentSpeed: this.drone.MaxDescentSpeed,
          MaxSpeed: this.drone.MaxSpeed,
          MaxWindResistance: this.drone.MaxWindResistance,
          Battery: this.drone.Battery,
          MaxFlightTime: this.drone.MaxFlightTime,
          RemoteBattery: this.drone.RemoteBattery,
          MaxTransmissionDistance: this.drone.MaxTransmissionDistance
        })
        .then(() => {
          if (this.errorMsg != "") {
            swal
              .fire({
                title: "Cannot Update Drone",
                text: this.$t(this.errorMsg),
                type: "error",
                confirmButtonClass: "md-button md-error",
                buttonsStyling: false
              })
              .then(() => {
                this.errorMsg = "";
                this.editing = false;
              });
          } else {
            this.editing = false;
          }
        });
    }
  },
  beforeMount() {
    if (this.$store.state.auth.usertype !== "admin") {
      swal
        .fire({
          title: "Warning",
          text: "Only administrator can access here!",
          type: "warning",
          confirmButtonClass: "md-button md-warning",
          buttonsStyling: false
        })
        .then(() => {
          router.push("/profile");
        });
    }
    this.$store.dispatch("drone/getDroneList");
  },
  mounted() {}
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
